import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { KnzComponentProps } from '../../../types';
import { SERIF_FONT } from './proseStyle';

/**
 * 読み物の引用（thoughts-ai の Blockquote 相当）。明朝体・左ボーダー。
 * params: text（joined, Markdown 可）
 */
export const ProseQuote: React.FC<KnzComponentProps> = ({ node, renderInline }) => {
  const text = (node.params.text as string) ?? '';
  return (
    <Box sx={{ borderLeft: '3px solid #C8C3B8', pl: 2, my: 2 }}>
      <Typography
        component="div"
        sx={{
          fontSize: 14,
          fontFamily: SERIF_FONT,
          color: '#333333',
          lineHeight: 2.0,
          '& .wmde-markdown, & .wmde-markdown p, & .wmde-markdown span': {
            margin: 0,
            fontFamily: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            color: 'inherit',
            background: 'transparent',
          },
        }}
      >
        {renderInline(text)}
      </Typography>
    </Box>
  );
};

export default ProseQuote;
